import { FormControl } from '@angular/forms';
export class IfscValidator {
  static validIfsc(fc: FormControl){

    var numpattern = /[0-9]/g;
    var alphapattern = /[a-zA-Z]/g;
    if (fc.value != undefined) {
      var viewValue = fc.value;
    
      var matifsc = (viewValue.match(numpattern) || []).length;
      var matifsc1 = (viewValue.match(alphapattern) || []).length;
      if (matifsc >= 1 && matifsc1 >= 1) {
        return null
    } else {
        return ({ validifsc: true });
    }   

  }
  }
}